import React from "react";
import { CircularProgress } from '@mui/material';
import "./LoadingGrid.scss";

export default function LoadingGrid({single}) {
  const sections = [1,2,3,4];
  return (
    <div className="loading-wrapper">
      <CircularProgress/>
      { !single ? <div className="loading-grid">
        {sections.map((s, i) => {
          return (
            <div className="item" key={i}>
              <div className="item-section-full">
                <div className="fill"></div>
              </div>
              <div className="item-section upper">
                <div className="stack-fill"></div>
                <div className="stack-fill"></div>
              </div>
              <div className="item-section lower">
                <div className="stack-fill"></div>
                <div className="stack-fill"></div>
              </div>
              <div className="item-section-full">
                <div className="fill short"></div>
              </div>
              <div className="item-section-full">
                <div className="fill"></div>
              </div>
              <div className="item-section center">
                <div className="medium-fill"></div>
              </div>
              <div className="item-section center">
                <div className="small-fill"></div>
              </div>
            </div>
          )
        })}
        <div className="footer-section">
          <div className="small-fill"></div>
          <div className="fill"></div>
        </div>
      </div> : 
      <div className="loading-grid single">
        <div className="item">
          <div className="item-section-full">
            <div className="fill"></div>
          </div>
          <div className="item-section upper">
            <div className="stack-fill"></div>
            <div className="stack-fill"></div>
          </div>
          <div className="item-section lower">
            <div className="stack-fill"></div>
            <div className="stack-fill"></div>
          </div>
          <div className="item-section-full">
            <div className="fill short"></div>
          </div>
          <div className="item-section-full">
            <div className="fill"></div>
          </div>
          <div className="item-section center">
            <div className="medium-fill"></div>
          </div>
          <div className="item-section center">
            <div className="small-fill"></div>
          </div>
        </div>
      </div>}
    </div>
  )
}